import { Role } from '../_helpers/models/role';
import { ContrackConstants } from '../_helpers/other/contrack-constants';
import * as i0 from "@angular/core";
export class RoleService {
    constructor() {
    }
    static setUsersPrivilege(menuPrivilages) {
        this.usersPrivilege = menuPrivilages;
    }
    static checkPrivilege(subMenuCode) {
        return this.getUsersPrivilege[subMenuCode];
    }
    static get getUsersPrivilege() {
        return this.getDefaultUsersPrivilege;
    }
    static get getDefaultUsersPrivilege() {
        if (RoleService.checkRolePortalAdmin()) {
            RoleService.usersPrivilege = ContrackConstants.portalAdminDefaultPrivilege;
        }
        else if (RoleService.checkRoleCustomer()) {
            RoleService.usersPrivilege = ContrackConstants.customerDefaultPrivilege;
        }
        else if (RoleService.checkRoleRM()) {
            RoleService.usersPrivilege = ContrackConstants.regionalManagerDefaultPrivilege;
        }
        else if (RoleService.checkRoleBM()) {
            RoleService.usersPrivilege = ContrackConstants.branchManagerDefaultPrivilege;
        }
        else if (RoleService.checkRolePM()) {
            RoleService.usersPrivilege = ContrackConstants.propertyManagerDefaultPrivilege;
        }
        else if (RoleService.checkRoleVendor()) {
            RoleService.usersPrivilege = ContrackConstants.vendorDefaultPrivilege;
        }
        else if (RoleService.checkRoleRMV()) {
            RoleService.usersPrivilege = ContrackConstants.regionalManagerVendorDefaultPrivilege;
        }
        else if (RoleService.checkRoleBMV()) {
            RoleService.usersPrivilege = ContrackConstants.branchManagerVendorDefaultPrivilege;
        }
        else if (RoleService.checkRoleLV()) {
            RoleService.usersPrivilege = ContrackConstants.localVendorDefaultPrivilege;
        }
        return this.usersPrivilege;
    }
    static getCurrentUserRole() {
        if (RoleService.checkRolePortalAdmin()) {
            return Role.PORTAL_ADMIN;
        }
        else if (RoleService.checkRoleCustomer()) {
            return Role.CUSTOMER_ADMIN;
        }
        else if (RoleService.checkRoleRM()) {
            return Role.ROLE_RM;
        }
        else if (RoleService.checkRoleBM()) {
            return Role.ROLE_BM;
        }
        else if (RoleService.checkRolePM()) {
            return Role.ROLE_PM;
        }
        else if (RoleService.checkRoleVendor()) {
            return Role.ROLE_VENDOR;
        }
        else if (RoleService.checkRoleCrewLead()) {
            return Role.ROLE_CREW_LEAD;
        }
        else if (RoleService.checkRoleRMV()) {
            return Role.ROLE_RMV;
        }
        else if (RoleService.checkRoleBMV()) {
            return Role.ROLE_BMV;
        }
        else if (RoleService.checkRoleLV()) {
            return Role.ROLE_LV;
        }
        else {
            return null;
        }
    }
    static checkRolePortalAdmin() {
        return RoleService.checkCurrentUserRole('PORTAL_ADMIN');
    }
    static checkRoleCustomer() {
        return RoleService.checkCurrentUserRole('CUSTOMER_ADMIN');
    }
    static checkRoleRM() {
        return RoleService.checkCurrentUserRole('ROLE_RM');
    }
    static checkRoleBM() {
        return RoleService.checkCurrentUserRole('ROLE_BM');
    }
    static checkRolePM() {
        return RoleService.checkCurrentUserRole('ROLE_PM');
    }
    static checkRoleVendor() {
        return RoleService.checkCurrentUserRole('ROLE_VENDOR');
    }
    static checkRoleCrewLead() {
        return RoleService.checkCurrentUserRole('ROLE_CREW_LEAD');
    }
    static checkRoleRMV() {
        return RoleService.checkCurrentUserRole('ROLE_RMV');
    }
    static checkRoleBMV() {
        return RoleService.checkCurrentUserRole('ROLE_BMV');
    }
    static checkRoleLV() {
        return RoleService.checkCurrentUserRole('ROLE_LV');
    }
    static checkCurrentUserRole(userRole) {
        if (!sessionStorage.hasOwnProperty('roles')) {
            return false;
        }
        const roles = JSON.parse(sessionStorage.getItem('roles'));
        for (const role of roles) {
            if (role === userRole) {
                return true;
            }
        }
        return false;
    }
}
RoleService.usersPrivilege = ContrackConstants.defaultPrivilege;
RoleService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RoleService_Factory() { return new RoleService(); }, token: RoleService, providedIn: "root" });
